import type { ReactNode } from 'react';
import { CaretRightIcon } from '@/icons';
import PaletteShell from './PaletteShell';
import { classes, styles } from './utils';

export type CommandPaletteItem<T extends string> = {
  value: T;
  prefix: string;
  hotkey: string;
  label: string;
  accent: string;
};

export interface CommandPaletteProps<T extends string> {
  icon: ReactNode;
  title: string;
  subtitle: string;
  items: readonly CommandPaletteItem<T>[];
  onSelect: (value: T) => void;
  onClose: () => void;
}

export default function CommandPalette<T extends string>({
  icon,
  title,
  subtitle,
  items,
  onSelect,
  onClose,
}: CommandPaletteProps<T>) {
  return (
    <PaletteShell onClose={onClose}>
      <div className={classes.header}>
        <div className={classes.badge}>{icon}</div>
        <div className={classes.titles}>
          <span className={classes.title}>{title}</span>
          <span className={classes.subtitle}>{subtitle}</span>
        </div>
      </div>
      <div className={classes.divider} />
      <div className={classes.list}>
        {items.map((item) => (
          <button
            key={item.value}
            className={classes.row}
            onClick={() => onSelect(item.value)}>
            <span style={styles.keycap(item.accent)} className={classes.keycap}>
              <span className={classes.prefix}>{item.prefix}</span>
              {item.hotkey}
            </span>
            <span className={classes.label}>{item.label}</span>
            <CaretRightIcon className={classes.chevron} />
          </button>
        ))}
      </div>
    </PaletteShell>
  );
}
